import {
  DeviceIdentityListRes,
  DeviceIdentityDetailsRes,
  DeviceTaskItem,
  TaskQuery,
  DeviceInfoQuery,
  DeviceInfoItemRes,
  DeviceInfoItem,
  DeviceInfoAddRes,
  DeviceDeletionQuery,
  DeviceIdentityBaseRes,
  DeviceDetailsQuery,
  DeviceCountQuery,
  DeviceIdentityCountRes,
  DeviceCountUpdate,
  DeviceInfoBulkUpload,
  DeviceInfoUpdateBulkUpload,
  DeviceProductCountQuery,
  DeviceIdentityProductCountRes,
  DeviceMaxProductCountQuery,
} from './type';
import { http } from './http';

export const getTaskList = (query: TaskQuery) => {
  return http.get<DeviceIdentityListRes<DeviceTaskItem>>('/task', {
    params: query,
  });
};

export const getTaskDetails = (taskId: string) => {
  return http.get<DeviceIdentityDetailsRes<DeviceTaskItem>>('/task-details', {
    params: {
      taskId: taskId,
    },
  });
};

export const getDeviceList = (query: DeviceInfoQuery) => {
  return http.get<DeviceIdentityListRes<DeviceInfoItemRes>>('/deviceinfo', {
    params: query,
  });
};

export const createDevice = (data: DeviceInfoItem[]) => {
  return http.post<DeviceIdentityDetailsRes<DeviceInfoAddRes[]>>(
    '/deviceinfo',
    {
      data: data,
    },
  );
};

export const createDeviceCsv = (data: DeviceInfoBulkUpload) => {
  return http.post<DeviceIdentityDetailsRes<string>>('/deviceinfo-csv', {
    data: data,
  });
};

export const updateDevice = (data: DeviceInfoItem[]) => {
  return http.put<DeviceIdentityDetailsRes<DeviceInfoAddRes[]>>('/deviceinfo', {
    data: data,
  });
};

export const updateDeviceCsv = (data: DeviceInfoUpdateBulkUpload) => {
  return http.put<DeviceIdentityDetailsRes<string>>('/deviceinfo-csv', {
    data: data,
  });
};

export const deleteDevice = (query: DeviceDeletionQuery) => {
  return http.delete<DeviceIdentityBaseRes>('/deviceinfo', {
    params: query,
  });
};

export const getDeviceDetails = (query: DeviceDetailsQuery) => {
  return http.get<DeviceIdentityDetailsRes<DeviceInfoItemRes>>(
    '/deviceinfo-details',
    {
      params: query,
    },
  );
};

export const getDeviceCount = (query: DeviceCountQuery[]) => {
  return http.post<DeviceIdentityCountRes>('/deviceinfo-count', {
    data: query,
  });
};

export const updateProjectDeviceCount = (query: DeviceCountUpdate) => {
  return http.post('/update_device_count', {
    data: query,
  });
};

export const syncProjectDeviceCount = () => {
  return http.post('/sync_device_count');
};

export const getDeviceProductCount = (query: DeviceProductCountQuery) => {
  return http.get<DeviceIdentityProductCountRes>('/deviceinfo-product-count', {
    params: query,
  });
};

export const setDeviceMaxProductCount = (
  query: DeviceMaxProductCountQuery,
  projectId: string,
) => {
  return http.post('/deviceinfo-max-product-count', {
    data: query,
    params: {
      projectId: projectId,
    },
  });
};
